import React from 'react';
import { Link } from 'react-router-dom';
import { PiClipboardTextLight, PiScrollLight } from 'react-icons/pi';
import {
  BullhornIcon,
  CalendarIcon,
  NewspaperIcon,
  VideoIcon,
} from '../Icons/SiteIcons';

const QuickMenu = () => {
  const menuItems = [
    { icon: <NewspaperIcon />, text: 'Haberler', link: '/haberler' },
    { icon: <BullhornIcon />, text: 'Güncel Duyurular', link: '/duyurular' },
    { icon: <PiScrollLight />, text: 'Güncel İhaleler', link: '/ihaleler' },
    { icon: <PiClipboardTextLight />, text: 'Güncel İlanlar', link: '/ilanlar' },
    { icon: <CalendarIcon />, text: 'Etkinlikler', link: '/etkinlikler' },
    { icon: <VideoIcon />, text: 'Video Galeri', link: '/videolar' },
  ];

  return (
    <div className="col-lg-2 col-md-5 z-index-9 p-0">
      <div className="quick-menu">
        <div className="quick-menu-container">
          <div className="quick-menu-title">
            Hızlı Menü
          </div>
          <ul className="quick-menu-list">
            {menuItems.map((item, index) => (
              <li key={index} className="quick-menu-item">
                <Link to={item.link} className="quick-menu-link">
                  <span className="quick-menu-icon">{item.icon}</span>
                  <span className="quick-menu-text">{item.text}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default QuickMenu;
